"use strict";

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toBoolean = exports.convertToColumnTypes = void 0;
var enums_1 = require("../enums");
var DataUtils_1 = require("./DataUtils");
var convertToColumnTypes = function convertToColumnTypes(data, columns) {
  var columnsToReplace = __spreadArray([], columns, true);
  var dataCopy = __spreadArray([], data, true);
  columnsToReplace.forEach(function (c) {
    if (c.dataType && c.dataType !== enums_1.DataType.Object) {
      for (var i = 0; i < dataCopy.length; i++) {
        var value = (0, DataUtils_1.getValueByColumn)(dataCopy[i], c);
        if (value != null) {
          switch (c.dataType) {
            case enums_1.DataType.String:
              if (value.constructor !== String) {
                dataCopy[i] = (0, DataUtils_1.replaceValue)(dataCopy[i], c, value.toString());
                continue;
              }
              break;
            case enums_1.DataType.Number:
              if (value.constructor !== Number) {
                dataCopy[i] = (0, DataUtils_1.replaceValue)(dataCopy[i], c, Number(value));
                continue;
              }
              break;
            case enums_1.DataType.Date:
              if (value.constructor !== Date) {
                dataCopy[i] = (0, DataUtils_1.replaceValue)(dataCopy[i], c, new Date(value));
                continue;
              }
              break;
            case enums_1.DataType.Boolean:
              if (value.constructor !== Boolean) {
                dataCopy[i] = (0, DataUtils_1.replaceValue)(dataCopy[i], c, (0, exports.toBoolean)(value));
                continue;
              }
              break;
          }
          break;
        }
      }
    }
  });
  return dataCopy;
};
exports.convertToColumnTypes = convertToColumnTypes;
var toBoolean = function toBoolean(value) {
  if (typeof value === 'string') {
    switch (value.toLowerCase().trim()) {
      case 'true':
      case 'yes':
      case '1':
        return true;
      case 'false':
      case 'no':
      case '0':
      case null:
        return false;
    }
  }
  return Boolean(value);
};
exports.toBoolean = toBoolean;